import type { SuperDef } from "../../sim";

/**
 * «Шквал» — общий суперприём манекенов: рывок с ударом; попал — пять ударов крупным планом (рука, хук, нога,
 * разворот, апперкот) и финальный удар через всю арену. Около 37 % здоровья. Герои получат свои серии.
 */
export const SQUALL: SuperDef = {
  id: "squall",
  name: "ШКВАЛ",
  opener: { startup: 10, active: 8, recovery: 34, hitbox: { x: 24, y: -136, w: 70, h: 44 }, lunge: 12 },
  hits: [
    { frame: 26, damage: 40, pose: "jab" },
    { frame: 42, damage: 45, pose: "hook" },
    { frame: 58, damage: 50, pose: "lightKick" },
    { frame: 74, damage: 55, pose: "heavyKick" },
    { frame: 92, damage: 60, pose: "uppercut" },
  ],
  finale: { frame: 116, damage: 120, launch: 16, push: 18, pose: "dashStrike" },
  length: 140,
  holdDistance: 62,
};

export const SUPERS: ReadonlyMap<string, SuperDef> = new Map([[SQUALL.id, SQUALL]]);
